module.exports = __webpack_public_path__ + "static/img/people-having-fun.e119e83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/people-having-fun.jpg
// module id = IrXz
// module chunks = 1